import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=161bcdf2&scoped=true"
import script from "./Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Details.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=161bcdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bcdf2",
  null
  
)

export default component.exports